<img
  [src]="imgSrc"
  (error)="onError($event)"
  [ngClass]="{ 'hover-zoom': hoverZoom, hide: isRetrying }"
/>

<mat-spinner class="spinner" *ngIf="isRetrying"></mat-spinner>
